import { combineReducers } from "@reduxjs/toolkit";
import appointmentReducer from "./appointmentSlice";
import dashboardAnalyticsReducer from "./dashboardAnalyticsSlice";
import dashboardReducer from "./dashboardSlice";
import errorReducer from "./errorSlice";
import facilityReducer from "./facilitySlice";
import licenceReducer from "./licenceSlice";
import loaderReducer from "./loaderSlice";
import notificationReducer from "./notificationSlice";
import patientReducer from "./patientSlice";
import sessionReducer from "./sessionSlice";
import specialtiesReducer from "./specialtiesSlice";

export const rootReducer = combineReducers({
  session: sessionReducer,
  dashboard: dashboardReducer,
  dashboardAnalytics: dashboardAnalyticsReducer,
  appointments: appointmentReducer,
  patients: patientReducer,
  loader: loaderReducer,
  error: errorReducer,
  facility: facilityReducer,
  licence: licenceReducer,
  specialties: specialtiesReducer,
  notifications: notificationReducer,
});
